import { ref, watch } from 'vue'

const STORAGE_KEY = 'tableItemsPerPage'

export function useTableItemsPerPage(moduleName: string, defaultVal: number = 25) {
  const getStoredValue = (): number => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (parsed && typeof parsed === 'object' && parsed[moduleName] !== undefined) {
          return Number(parsed[moduleName])
        }
      }
    } catch (e) {
      console.error('Error reading itemsPerPage from localStorage', e)
    }
    return defaultVal
  }

  const itemsPerPage = ref<number>(getStoredValue())

  watch(itemsPerPage, newVal => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      const parsed = stored ? JSON.parse(stored) : {}
      parsed[moduleName] = newVal
      localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed))
    } catch (e) {
      console.error('Error writing itemsPerPage to localStorage', e)
    }
  })

  return {
    itemsPerPage,
  }
}
